<template>
    <ul class="userleft">
        <li v-for="(item,index) in userleft" :key="index"  class="usermenu">
            <p>{{item.menutitle}}</p>
            <ul v-if="item.children">
                <li v-for="(obj,j) in item.children" :class="menuPath==obj.path?'onmenu':''" class="secondmenu" :key="j" @click="routerTo(obj.path)">
                    <el-badge v-if="obj.title==='消息通知' && (weidu_count > 0 || unread_count > 0) " :value="weidu_count ? weidu_count : unread_count" >
                        <span>{{obj.title}}</span>
                    </el-badge>
                    <span v-else>{{obj.title}}</span>
                </li>
            </ul>
        </li>

    </ul>
</template>

<script>
    import userInfo from "../api/userInfo";
    import members from '@/api/members'

    export default {
        name: 'LeftMenu',
        props:{
            weidu_count : {
                type : Number,
                required:true
            }
        },
        data() {
            return {
                menuPath:this.$route.name,
                userleft:[

                ],
                unread_count:0
            }

        },
        created() {
            this.getUserinfo();
             this.getCountsOfTypes()
        },
        methods:{
            routerTo(obj){
                if(obj=='Logout'){
                    this.$confirm("确定退出登录吗？", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        localStorage.clear();
                        this.$router.push({
                            name: 'Login',
                        })
                    });
                }else{
                    this.$router.push({
                        name: obj,
                        params: {
                            query:{t:obj},
                            path:obj
                        }
                    })
                }
            },
            getUserinfo(){
                userInfo.getUserinfo().then(res => {
                    if (res.data.code === 200) {
                        if(res.data.data.email){
                            localStorage.setItem('email',res.data.data.email)
                        }
                        if(res.data.data.mobile){
                            localStorage.setItem('mobile',res.data.data.mobile)
                        }
                        if(res.data.city){
                            localStorage.setItem('city',res.data.city)
                        }
                        if(res.data.department_name){
                            localStorage.setItem('department_name',res.data.department_name)
                        }
                        if(res.data.data.is_vipTeam === 1){
                            
                                this.userleft.push({
                                    menutitle:"学会业务",
                                    children:[{
                                        title:"会员状态",
                                        path:"Application"
                                    }]
                                },
                                {
                                    menutitle:"生物竞赛",
                                    children:[{
                                        title:"报名列表",
                                        path:"ApplyList"
                                    }
                                    ]

                                },
                                {
                                    menutitle:"账号安全",
                                    children:[{
                                        title:"用户基本信息",
                                        path:"AboutUs"
                                    },{
                                        title:"修改密码",
                                        path:"Password"
                                    },{
                                        title:"消息通知",
                                        path:"Notice"
                                    },{
                                        title:"退出登录",
                                        path:"Logout"
                                    }]

                                })

                                let data = {
                                    city : res.data.city,
                                    department_name : res.data.department_name
                                }
                                this.$emit('transfer',data)
                        }else{
                            this.userleft.push({
                                    menutitle:"学会业务",
                                    children:[{
                                        title:"会员状态",
                                        path:"Application"
                                    }]

                                },

                                {
                                    menutitle:"账号安全",
                                    children:[{
                                        title:"用户基本信息",
                                        path:"AboutUs"
                                    },{
                                        title:"修改密码",
                                        path:"Password"
                                    },{
                                        title:"消息通知",
                                        path:"Notice"
                                    },{
                                        title:"退出登录",
                                        path:"Logout"
                                    }]

                                })



                        }

                    }


                });
            },
             getCountsOfTypes(){
                if(this.weidu_count == undefined){
                    members.getCountsOfTypes().then(res => {
                        if(res.data.code === 200){
                            this.unread_count = res.data.data.unread_count
                            
                        }
                    });
                }
                
               
            },

        }
    }
</script>

<style scoped>

</style>
